/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserShort } from './userShort';
import type { WorkState } from './workState';
import type { StudentEngagementRecordLevelProgress } from './studentEngagementRecordLevelProgress';
import type { StudentEngagementRecordLastActivity } from './studentEngagementRecordLastActivity';

/**
 * A record of a student's engagement in a module under a lecturer's mandate
 */
export interface StudentEngagementRecord {
  student: UserShort;
  moduleId: string;
  moduleTitle: string;
  moduleVersion: string;
  courseId: string;
  workState: WorkState;
  levelProgress?: StudentEngagementRecordLevelProgress;
  lastActivity: StudentEngagementRecordLastActivity;
}
